import {automationNotificationLocation} from '../automation/automationLogLinks';

export function getNotificationTarget(notification, background) {
    const redirectUrl = notification?.data?.redirectUrl;
    if (typeof redirectUrl === 'string') {
        const url = redirectUrl.trim();
        // Only app paths and HTTPS destinations can be opened from API data.
        // eslint-disable-next-line no-control-regex -- Control characters must not alter URL parsing.
        if (url && !/[\u0000-\u001f\u007f\\]/.test(url)) {
            if (url.startsWith('/') && !url.startsWith('//')) {
                return {location: url, external: false, label: 'Open notification'};
            }
            if (/^https:\/\//i.test(url)) {
                try {
                    const destination = new URL(url);
                    if (destination.hostname && !destination.username && !destination.password) {
                        return {location: destination.href, external: true, label: 'Open notification'};
                    }
                } catch {
                    // Invalid redirects can still fall back to automation details.
                }
            }
        }
    }

    const location = automationNotificationLocation(notification, background);
    return location ? {location, external: false, label: 'View logs'} : null;
}
